import type { ReactNode, SVGProps } from "react";

export function ApiManagementIcon(props: SVGProps<SVGSVGElement>): ReactNode {
	return (
		<svg
			fill="none"
			height="16"
			viewBox="-1.125 -1.875 17 17"
			width="16"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M3.625 3.625L0.625 6.625L3.625 9.625"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M11.125 3.625L14.125 6.625L11.125 9.625"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M8.875 0.625L5.875 12.625"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
		</svg>
	);
}
